import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import GraphicalEnvelope from "components/instruments/envelope/GraphicalEnvelope.js"

const ZEnvelopeComponent = ({zobject, height, width, zenvelope, lineColor, fillColor, backgroundColor}) => { 
    if (!zenvelope.envelope) {
        return '';
    }
    return (<GraphicalEnvelope
              fillColor={fillColor}
              lineColor={lineColor}
              width={width}
              height={height}
              backgroundColor={backgroundColor}
              name="Env"
              draggable={false}
              hasRelease={true}
              envelope={zenvelope.envelope}/>);
}

const mapStateToProps = (state, props) => {
  return {
      envelope: props.zenvelope.envelope,
      width: props.zobject.width,
      height: props.zobject.height,
      lineColor: props.zobject.attributes["primary-color"],
      fillColor: props.zobject.attributes["primary-color"],
      backgroundColor: props.zobject.attributes["secondary-color"],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZEnvelopeComponent);
